interface Props {
  total: number;
  activeIndex: number;
  onDotClick?: (index: number) => void;
}

const TabDots = ({ total, activeIndex, onDotClick }: Props) => {
  if (total <= 1) return null;
  return (
    <div className="flex justify-center gap-1.5 py-2">
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i}
          onClick={() => onDotClick?.(i)}
          className={`rounded-full transition-all duration-200 ${
            i === activeIndex
              ? "w-5 h-1.5 bg-primary"
              : "w-1.5 h-1.5 bg-muted-foreground/30 hover:bg-muted-foreground/50"
          }`}
          aria-label={`Go to tab ${i + 1}`}
        />
      ))}
    </div>
  );
};

export default TabDots;
